import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiboxIconComponent } from './servibox-icon.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ServiboxIconComponent],
  exports: [ServiboxIconComponent],
})
export class ServiboxIconModule { }
